import { render, staticRenderFns } from "./ListTruckTrailer.vue?vue&type=template&id=57cc2d2c&"
import script from "./ListTruckTrailer.vue?vue&type=script&lang=js&"
export * from "./ListTruckTrailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports